import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import EditBatch from "../../components/Batches/EditBatch";


const EditBatches = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Batch  </h5><Breadcrumb title="Edit batch" /></div>

        {/* UsersListLayer */}
        <EditBatch />


    </>
  );
};

export default EditBatches; 